import { useEffect, useState } from 'react'
import CicloEntregaAcoesHttp from '../../../../../services/api/https/deliveries/ciclo-entrega-acoes.http'
import { downloadFile } from '../../../../../services/util/download.service'
import { errorHandler } from '../../../../../services/util/error.service'

export const MAPA_PESO_CIDADE_ACTIONS = {
  EXPORTANDO_MAPA: 'EXPORTANDO_MAPA',
  NONE: 'NONE',
}

const INITIAL_STATE = {
  errorMessage: null,
  successMessage: null,
  loading: MAPA_PESO_CIDADE_ACTIONS.NONE,
}

export default function useMapaPesoCidade(ciclo) {
  const [state, setState] = useState(INITIAL_STATE)

  useEffect(() => {
    ciclo.id && !Number.isNaN(ciclo.id) && exportarMapaPesoCidade()
  }, [ciclo.id])

  const actions = {
    onBtnExportarClick() {
      exportarMapaPesoCidade()
    },
    resetMessages() {
      setState(prevState => ({ ...prevState, errorMessage: null, successMessage: null }))
    },
  }

  async function exportarMapaPesoCidade() {
    try {
      setState(prevState => ({
        ...prevState,
        loading: MAPA_PESO_CIDADE_ACTIONS.EXPORTANDO_MAPA,
        errorMessage: null,
        successMessage: null,
      }))

      const file = await CicloEntregaAcoesHttp.downloadMapaPesoCidade(ciclo.id)
      downloadFile(file, `${ciclo.id}_Mapa_Peso_Cidade.xlsx`)

      setState(prevState => ({
        ...prevState,
        loading: MAPA_PESO_CIDADE_ACTIONS.NONE,
        successMessage: 'Mapa de Peso por Cidade exportado com sucesso',
      }))
    } catch (error) {
      setState(prevState => ({
        ...prevState,
        loading: MAPA_PESO_CIDADE_ACTIONS.NONE,
        errorMessage: errorHandler(error),
      }))
    }
  }

  return { state, actions }
}
